module.exports = __webpack_public_path__ + "static/media/imaginxp-logo.ff56935c.png";